import { gql } from '@apollo/client';

export const CREATE_RETURN_REASON = gql`
  mutation CreateReturnReason($storeId: ID!, $description: String!) {
    createReturnReason(storeId: $storeId, description: $description) {
      ... on CreateReturnReasonSuccess {
        code
        returnReason {
          id
          description
          isSelected
        }
      }
      ... on Error {
        message
        code
      }
      __typename
    }
  }
`;

export const GET_STORE_CONFIGS_AND_RULES = gql`
  query getStoreConfigsAndRules($storeId: ID!) {
    reasons: getReturnReasonsByStore(storeId: $storeId) {
      __typename
      ... on GetReturnReasonsByStoreSuccess {
        code
        returnReasons {
          id
          description
          isSelected
        }
      }
      ... on Error {
        message
        code
      }
    }
    categories: getEligibleCategories(storeId: $storeId) {
      __typename
      ... on GetEligibleCategoriesSuccess {
        code
        orderItemCategories {
          id
          name
          eligible
        }
      }
      ... on Error {
        message
        code
      }
    }
    storeConfigs: getStoreConfigs(storeId: $storeId) {
      __typename
      ... on GetStoreConfigsSuccess {
        code
        storeConfigs {
          id
          storeId
          returnWindowDays
          autoApproveDevolution
          considerDevolutionItems
          enableVtexItemsSearch
          showCountdownScreen
          enableReturnMethodSelectionEmail
          enableOrderNumberInput
          enableMemphisOrderInfoSearch
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;

export const SAVE_STORE_CONFIG_AND_RULES = gql`
  mutation SaveStoreConfigsAndRules(
    $storeId: ID!
    $markIneligibleCategories: [ID!]!
    $removeIneligibleCategories: [ID!]!
    $returnReasons: [ReturnReasonInput!]!
    $updateStoreConfigs: UpdateStoreConfigsInput!
  ) {
    setCategoriesAsIneligible: setCategoriesAsIneligible(
      storeId: $storeId
      categories: $markIneligibleCategories
    ) {
      __typename
      ... on SetCategoriesAsIneligibleSuccess {
        code
        message
      }
      ... on Error {
        message
        code
      }
    }
    removeCategoriesFromIneligible: removeCategoriesFromIneligible(
      storeId: $storeId
      categories: $removeIneligibleCategories
    ) {
      __typename
      ... on RemoveCategoriesFromIneligibleSuccess {
        code
        message
      }
      ... on Error {
        message
        code
      }
    }
    toggleReturnReasonSelection: toggleReturnReasonSelection(
      storeId: $storeId
      returnReasons: $returnReasons
    ) {
      __typename
      ... on ToggleReturnReasonSelectionSuccess {
        code
        message
      }
      ... on Error {
        message
        code
      }
    }
    updateStoreConfigs: updateStoreConfigs(
      updateStoreConfigs: $updateStoreConfigs
    ) {
      __typename
      ... on UpdateStoreConfigsSuccess {
        code
        message
      }
      ... on Error {
        message
        code
      }
    }
  }
`;

export default {
  CREATE_RETURN_REASON,
  GET_STORE_CONFIGS_AND_RULES,
  SAVE_STORE_CONFIG_AND_RULES,
};
